import type { FC, ReactNode } from 'react';

import { CollapsibleSection } from '../../sidebar/components';

interface SectionProps {
  id: string;
  title: string;
  children: ReactNode;
}

export const Section: FC<SectionProps> = ({ id, title, children }) => (
  <CollapsibleSection
    title={title}
    defaultCollapsed={id !== 'general'}
    persistKey={`sl.viewConfig.section.${id}.open`}
    data-sl-role={`section-${id}`}
    contentId={`section-body-${id}`}
  >
    {children}
  </CollapsibleSection>
);
